import { createFileRoute } from '@tanstack/react-router';
import { ProfileSearchPage } from '@/features/profile-search';

/**
 * Profiles List Route - /profiles/list
 *
 * Implements profile search with dynamic table rendering.
 * Headers and rows are driven by the API response, so the backend
 * controls which columns appear and in what order.
 *
 * Features:
 * - Basic search (name, email)
 * - Profile status & status code dropdowns
 * - Advanced C-TRAC information filters (region, brand, job group, etc.)
 * - Personal information filters (gender)
 * - Dynamic column rendering from API headers
 * - Pagination
 */

export const Route = createFileRoute('/_auth/profiles/list')({
  component: ProfileSearchPage,
});
